import React from 'react';
import { TextField, MenuItem, FormHelperText, FormControl } from '@material-ui/core';

interface DropdownOption {
  name: string | number;
  icon?: React.ReactNode;
  disabled?: boolean;
  requireLogin?: boolean;
}

interface CustomDropdownProps {
  value: string | number | undefined;
  options: (string | number | DropdownOption)[];
  error?: string;
  onChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  classes: any;
  label: string;
}

const CustomerDropDownWithLock: React.FC<CustomDropdownProps> = ({
  value,
  options,
  classes,
  error,
  onChange,
  label,
}) => {
  const getOptionName = (option: any | string): string => {
    return typeof option === 'object' && option !== null && 'name' in option
      ? (option.name as string)
      : (option as string);
  };
  return (
    <FormControl fullWidth error={Boolean(error)}>
      <TextField
        fullWidth
        select
        label={label}
        variant="outlined"
        value={value}
        onChange={onChange}
        className={`${classes.dropDown} no-border`}
        SelectProps={{
          MenuProps: {
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          },
          renderValue: (selected) => {
            const selectedOption = options.find((option) => getOptionName(option) === selected);
            return (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <span>
                  <span>{selectedOption && getOptionName(selectedOption)}</span>
                </span>
                {selectedOption && typeof selectedOption === 'object' && selectedOption.icon}
              </div>
            );
          },
          inputProps: {
            style: { backgroundColor: '#fff', borderRadius: '4px !important', padding: '16px' },
            disableUnderline: true,
          },
        }}
        error={Boolean(error)}
      >
        {options.map((option, index) => (
          <MenuItem
            value={typeof option === 'object' && option !== null && 'name' in option ? option.name : option}
            key={index}
            className={classes.dropDownOption}
            disabled={typeof option === 'object' && option !== null && 'name' in option && option.disabled}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <span>{typeof option === 'object' && option !== null && 'name' in option ? option.name : option}</span>
              {typeof option === 'object' && option !== null && 'icon' in option && option.icon}
            </div>
          </MenuItem>
        ))}
      </TextField>
      {error ? <FormHelperText>{error}</FormHelperText> : null}
    </FormControl>
  );
};

export default CustomerDropDownWithLock;
